<template>
  <div class="ab-modal-login-btn">
    <div class="remark-words">
      <slot name="action-title"
        >0元企业认证，认证通过一次性赠送2000积分，每日赠送100积分</slot
      >
    </div>
    <Abbutton>
      <slot name="action-words">
        <a
          data-source="p"
          onmouseover="linkDataSource(this)"
          @click="showModal"
          target="_blank"
          >立即注册AB客 查看更多内容</a
        >
      </slot>
    </Abbutton>
    <inquiry-modal-vue
      :visible="visible"
      @cancel="handleCancel"
    ></inquiry-modal-vue>
  </div>
</template>

<script>
import Abbutton from "@/components/Abbutton.vue";
import inquiryModalVue from "@/components/InquiryModal2.vue";
export default {
  components: {
    Abbutton,
    inquiryModalVue,
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    showModal() {
      window.open("https://crm.cnabke.com/#/passport/register", "_blank");
      this.visible = true;
    },

    handleCancel() {
      this.visible = false;
    },
  },
};
</script>

<style lang="sass" scoped>
.ab-modal-login-btn{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .remark-words{
    // width: 319px;
    height: 17px;
    font-size: 12px;
    font-family: AlibabaPuHuiTiM;
    color: #333646;
    line-height: 17px;
    margin-bottom: 10px;
  }
}
::v-deep .ab-btn{
  width: 400px;
}
</style>
